import {
  FETCH_STORIES,
  FETCH_MOMENTS,
  FETCH_STORY,
  FETCH_ACCOUNT_SETTINGS,
  OPEN_STORY,
  CLOSE_STORY,
  FETCH_PREMIUM_STORIES,
  OPEN_CART_STORY,
  SET_DEEPLINK_STORY_ID,
  FETCH_STRIPE_SETTINGS,
  GET_MARKETING_BY_JOB,
  SHOW_MARKETING
} from 'shared/actions/types';

import { trackEvent } from 'shared/services/Analytics';
import StoryService from 'shared/services/StoryService';

import produce from 'immer';

const initialState = {
  stories: {
    byId: {},
    allIds: []
  },
  premiumStories: {
    byId: {},
    allIds: []
  },
  moments: {
    byId: {},
    allIds: []
  },

  storyMoments: {},
  accountSettings: {},
  stripeSettings: {},
  openStoryId: null,
  openCartStoryId: null,
  deeplinkStoryId: null,
  reKnockedOutMoment: {},
  selectedMarketing: {},
  showMarketing: false,
};

const fetchResource = (resource, payload, draft) => {
  if (Array.isArray(payload)) {
    payload.map((record, index) => {
      draft[resource].allIds[index] = record.id;
      draft[resource].byId[record.id] = record;
    })

  } else {
    draft[resource].byId[payload.id] = payload;
    draft[resource].allIds.push(payload.id);
  }

  draft[resource].allIds = draft[resource].allIds.filter((value, index, self) => {
    return self.indexOf(value) === index;
  })
  //.sort((a, b) => a - b);
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_STORIES:
      return produce(state, draft => fetchResource('stories', action.payload, draft));

    case FETCH_PREMIUM_STORIES:
      return produce(state, draft => fetchResource('premiumStories', action.payload, draft));

    case FETCH_MOMENTS:
      return produce(state, draft => {
        // remove temp moments (moments uploading w/ temp ID matching hash)
        // if their completed moments are received
        let idsToDelete = [];

        for (let moment of action.payload.moments) {
          for (let id of draft.moments.allIds) {
            if (moment.hash && id === moment.hash) {
              idsToDelete.push(id);
              delete draft.moments.byId[id];
              break;
            }
          }
        }

        draft.moments.allIds = draft.moments.allIds.filter(id => {
          return idsToDelete.indexOf(id) === -1;
        });

        // add new moments
        fetchResource('moments', action.payload.moments, draft);

        // associate moments with story
        let storyId = action.payload.storyId;
        let momentIds = action.payload.moments.map(m => m.id);
        let prevCache = draft.storyMoments[storyId] || [];

        draft.storyMoments[storyId] = prevCache.concat(momentIds)
          .filter((value, index, self) => self.indexOf(value) === index && idsToDelete.indexOf(value) === -1);
      });

    case FETCH_STORY:
      return produce(state, draft => {
        let story = draft.stories.byId[action.payload.id];
        if (story) {
          for (const k in action.payload) {
            story[k] = action.payload[k];
          }
        }
      });

    case FETCH_ACCOUNT_SETTINGS:
      return produce(state, draft => {
        draft.accountSettings[action.payload.storyId] = action.payload.settings;
      });

    case FETCH_STRIPE_SETTINGS:
      return produce(state, draft => {
        draft.stripeSettings[action.payload.storyId] = action.payload.settings;
      });

    case OPEN_STORY:
      // todo - refactor this out of the reducer
      // prevent rerunning.
      if (state.openStoryId !== action.payload.story.id) {
        trackEvent('Story.Open', {
          userId: action.payload.user.id,
          storyId: action.payload.story.id,
          storyName: action.payload.story.name,
          'Portal.Account': action.payload.story.account_id
        });

        new StoryService().markStoryViewed(action.payload.story.id);
      }

      return produce(state, draft => {
        draft.openStoryId = action.payload.story.id;
      });

    case OPEN_CART_STORY:
      if (state.openCartStoryId !== action.payload.story.id) {
        trackEvent('Cart.Story.Open', {
          userId: action.payload.user.id,
          storyId: action.payload.story.id,
          storyName: action.payload.story.name,
          'Portal.Account': action.payload.story.account_id
        });

        new StoryService().markStoryViewed(action.payload.story.id);
      }

      return produce(state, draft => {
        draft.openCartStoryId = action.payload.story.id;
      });

    case CLOSE_STORY:
      // todo - refactor this out of the reducer
      // prevent rerunning.
      if (state.openStoryId !== action.payload.story.id) {
        trackEvent('Story.Close', {
          userId: action.payload.user.id,
          storyId: action.payload.story.id,
          storyName: action.payload.story.name,
          'Portal.Account': action.payload.story.account_id
        });
      }

      return produce(state, draft => {
        draft.openStoryId = null;
      });

    case SET_DEEPLINK_STORY_ID:
      return produce(state, draft => {
        draft.deeplinkStoryId = action.payload;
      });

    case GET_MARKETING_BY_JOB:
      return produce(state, draft => {
        draft.selectedMarketing = action.payload;
      });

    case SHOW_MARKETING:
      return produce(state, draft => {
        draft.showMarketing = action.payload;
      });

    default:
      return state;
  }
}
